/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Bauartklasse {

    Bak1 = 'BAK1',

    Bak2 = 'BAK2',

    Bak3 = 'BAK3',

    Bak4 = 'BAK4',

    Bak5 = 'BAK5',

    Fhg1 = 'FHG1',

    Fhg2 = 'FHG2',

    Fhg3 = 'FHG3',

    Fhg4 = 'FHG4',

    Fhg5 = 'FHG5'
}

